"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogActionButton = void 0;
const react_1 = __importStar(require("react"));
const Button_1 = require("../../../Button");
const common_1 = require("../../../common");
const Icon_1 = require("../../../Icon");
const ActionView_1 = require("./types/ActionView");
const DialogActionButton_styles_1 = require("./DialogActionButton.styles");
const ButtonViews = {
    [ActionView_1.ACTION_VIEW.primary]: Button_1.BUTTON_VIEW.primary,
    [ActionView_1.ACTION_VIEW.secondary]: Button_1.BUTTON_VIEW.secondary,
    [ActionView_1.ACTION_VIEW.alternate]: Button_1.BUTTON_VIEW.alternate,
    [ActionView_1.ACTION_VIEW.text]: Button_1.BUTTON_VIEW.text
};
exports.DialogActionButton = react_1.default.memo(function DialogActionButton({ view, disabled, enable, text, iconSrc, onClick, onKeyDown, dataSelectorId }) {
    const internalDisabled = (0, react_1.useMemo)(() => !enable && disabled, [disabled, enable]);
    const ui = (0, react_1.useMemo)(() => ButtonViews[view || ActionView_1.ACTION_VIEW.primary] || Button_1.BUTTON_VIEW.primary, [view]);
    const dataIsTextView = (0, react_1.useMemo)(() => (ui === Button_1.BUTTON_VIEW.text ? 'true' : 'false'), [ui]);
    return (react_1.default.createElement(DialogActionButton_styles_1.StyledDialogActionButton, { ui: ui, disabled: internalDisabled, onClick: onClick, onKeyDown: onKeyDown, "data-selector-id": dataSelectorId, "data-is-text-view": dataIsTextView, controlHeight: common_1.CONTROL_HEIGHT.l, iconBefore: iconSrc ? react_1.default.createElement(Icon_1.Icon, { src: iconSrc, disabled: internalDisabled }) : null }, text));
});
//# sourceMappingURL=DialogActionButton.js.map